import { ConfigErrorTypeId as ConfigErrorTypeId$1, And as And$1, Or as Or$1, MissingData as MissingData$1, InvalidData as InvalidData$1, SourceUnavailable as SourceUnavailable$1, Unsupported as Unsupported$1, isConfigError as isConfigError$1, isAnd as isAnd$1, isOr as isOr$1, isInvalidData as isInvalidData$1, isMissingData as isMissingData$1, isMissingDataOnly as isMissingDataOnly$1, isSourceUnavailable as isSourceUnavailable$1, isUnsupported as isUnsupported$1, prefixed as prefixed$1, reduceWithContext as reduceWithContext$1 } from '../../internal/configError.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const ConfigErrorTypeId = ConfigErrorTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * The possible ways that loading configuration data may fail.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const And = And$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const Or = Or$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const MissingData = MissingData$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const InvalidData = InvalidData$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const SourceUnavailable = SourceUnavailable$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const Unsupported = Unsupported$1;

/**
 * Returns `true` if the specified value is a `ConfigError`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isConfigError = isConfigError$1;

/**
 * Returns `true` if the specified `ConfigError` is an `And`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isAnd = isAnd$1;

/**
 * Returns `true` if the specified `ConfigError` is an `Or`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isOr = isOr$1;

/**
 * Returns `true` if the specified `ConfigError` is an `InvalidData`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isInvalidData = isInvalidData$1;

/**
 * Returns `true` if the specified `ConfigError` is an `MissingData`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isMissingData = isMissingData$1;

/**
 * Returns `true` if the specified `ConfigError` contains only `MissingData` errors, `false` otherwise.
 *
 * @since 2.0.0
 * @categer getters
 */
const isMissingDataOnly = isMissingDataOnly$1;

/**
 * Returns `true` if the specified `ConfigError` is a `SourceUnavailable`,
 * `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isSourceUnavailable = isSourceUnavailable$1;

/**
 * Returns `true` if the specified `ConfigError` is an `Unsupported`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isUnsupported = isUnsupported$1;

/**
 * @since 2.0.0
 * @category utils
 */
const prefixed = prefixed$1;

/**
 * @since 2.0.0
 * @category folding
 */
const reduceWithContext = reduceWithContext$1;

export { And, ConfigErrorTypeId, InvalidData, MissingData, Or, SourceUnavailable, Unsupported, isAnd, isConfigError, isInvalidData, isMissingData, isMissingDataOnly, isOr, isSourceUnavailable, isUnsupported, prefixed, reduceWithContext };
